import { createEvent, restore, sample } from 'effector'
import { BudgetItemById, EditBudgetItem } from './types'
import { fx, path } from '../../../../libs'
import { getSectionList } from '../../sections/list/model'
import { $params, toPath } from '../../../../features/router'

export const budgetItemMounted = createEvent()

export const setBudgetItem = createEvent<BudgetItemById>()

export const submitEditBudgetItem = createEvent<EditBudgetItem>()

export const sectionListForSelectMounted = createEvent()

export const $budgetItem = restore(setBudgetItem, {
  id: '',
  sectionId: '',
  name: '',
})

export const getBudgetItem = fx<void, BudgetItemById>({
  method: 'GET',
  url: '/finance/budget_item/{budgetItemID}',
})

export const editBudgetItem = fx<Omit<EditBudgetItem, 'id'>, void>({
  method: 'PUT',
  url: '/finance/budget_item/{budgetItemID}',
})

sample({
  clock: budgetItemMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.budgetItemID
    }
    return {
      url: `/finance/budget_item/${id}`,
    }
  },
  target: getBudgetItem,
})

sample({
  clock: [getBudgetItem.doneData],
  fn: (doneData) => doneData.body,
  target: [setBudgetItem],
})

sample({
  clock: submitEditBudgetItem,
  fn: (budgetItem) => {
    return {
      url: `/finance/budget_item/${budgetItem.id}`,
      body: { section: String(budgetItem.section), name: budgetItem.name },
    }
  },
  target: editBudgetItem,
})

sample({
  clock: sectionListForSelectMounted,
  fn: () => ({}),
  target: getSectionList,
})

sample({
  clock: [editBudgetItem.doneData],
  target: toPath.prepend(path.finSystem.budgetItem.entry),
})
